export const filterByDropdown = (obj: any, listView: any) =>
  Object.keys(obj).filter(
    (k) =>
      listView.find((l: any) =>
        l.property.split('.').length > 1
          ? l.property.includes(k)
          : l.property.split(' ').join('').toLowerCase() === k.toLowerCase(),
      )?.active,
  );
